"use strict";
var ApiPackage = (function () {
    function ApiPackage() {
    }
    return ApiPackage;
}());
exports.ApiPackage = ApiPackage;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-package.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-package.model.js